import React, { useMemo } from 'react';

import { Link, LinkProps } from '@sbu/components.link';
import { Button, ButtonProps } from '@sumologic/yama-ds-components';

import { useChildOrganizations } from 'shared/hooks/useChildOrganizations';

export interface FederatedLinkProps
  extends Pick<
    LinkProps,
    'children' | 'href' | 'title' | 'onClick' | 'variant'
  > {
  deployment: string;
  tenantOrgId: string;
  tenantUrl: string;
  renderAsButton?: boolean;
  ButtonProps?: ButtonProps;
}

export const FederatedLink = ({
  children,
  deployment,
  href,
  tenantOrgId,
  tenantUrl,
  title,
  renderAsButton = false,
  ButtonProps,
  ...rest
}: FederatedLinkProps) => {
  const { data: organizationsData, loading } = useChildOrganizations();

  const childOrgId = `${deployment}-${tenantOrgId}`;
  const tenantHasSsoEnabled = useMemo(
    () =>
      organizationsData?.find(
        (organization) => organization.orgId === childOrgId
      )?.isSSOSetup,
    [organizationsData, childOrgId]
  );

  // tenantUrl contains the /sec path prefix
  const relayState = `${tenantUrl}${href}`;

  const searchParams = new URLSearchParams({
    provider: 'sumo',
    childOrgId: encodeURIComponent(childOrgId),
    relayState: encodeURIComponent(relayState),
  }).toString();

  const url = tenantHasSsoEnabled ? `/ui/?${searchParams}` : relayState;

  return renderAsButton ? (
    <Button
      href={url}
      disabled={loading}
      LinkComponent={(props) => <Link variant='a' {...props} />}
      title={title}
      {...ButtonProps}
    >
      {children}
    </Button>
  ) : (
    <Link href={url} disabled={loading} title={title} variant='a' {...rest}>
      {children}
    </Link>
  );
};
